import { render, staticRenderFns } from "./StoreManage.vue?vue&type=template&id=8a466506&scoped=true&"
import script from "./StoreManage.vue?vue&type=script&lang=js&"
export * from "./StoreManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a466506",
  null
  
)

export default component.exports